import { CurrencyPipe, DatePipe, Location, TitleCasePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { debounceTime } from 'rxjs';

import { ICreateBatchData } from 'src/app/models/create-batch-data';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { IFilterContracts } from 'src/app/models/filters';
import { HeaderTitle, IGenericResult, IHeaderItem, IPagination, Mode } from 'src/app/models/generic';
import { IFieldOrder } from 'src/app/models/manual-batch';
import { IContractSearchData, IListContract } from 'src/app/models/verification';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { DataService } from 'src/app/services/data.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

import { ApiDialogService } from '../../../services/api/api-cdialog.service';
import { EstornarCardComponent } from '../../estornar-card/estornar-card.component';

@Component({
  selector: 'app-esteira-list',
  templateUrl: './esteira-list.component.html',
  styleUrls: ['./esteira-list.component.scss']
})
export class EsteiraListComponent implements OnInit, AfterViewInit {
  @ViewChild('contractsHeaderFix') contractsHeaderFixRef?: ElementRef<HTMLDivElement>;
  @ViewChild('contractsRegion') contractsRegionRef?: ElementRef<HTMLDivElement>;
  @ViewChild('contractsList') contractsListRef?: ElementRef<HTMLDivElement>;

  contracts: IListContract[] = [];
  title: HeaderTitle = 'Esteira de Apuração';
  createBatch: ICreateBatchData = { showCreateBatchButton: false };

  checkedContracts: IListContract[] = [];

  disabledCheckbox: IListContract[] = [];

  take = 50;
  skip = 0;
  fields: IFieldOrder[] = [];
  count = 0;

  filters!: IFilterContracts;
  currentContext: 'invoice' | 'transfer' = 'invoice';

  searchText = '';

  search!: string;

  totalAmount = 0;
  paginationResetKey = 0;
  isContractsHeaderPinned = false;
  contractsHeaderHeight = 0;
  contractsHeaderLeft = 0;
  contractsHeaderWidth = 0;
  private readonly enablePinnedHeader = false;

  headerItems: IHeaderItem[] = [
    {
      label: 'Contrato',
      flexSize: 1
    },
    {
      label: 'Data Contrato',
      flexSize: 1,
      name: 'ContractDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Produto',
      flexSize: 1,
      name: 'ContractType',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Banco',
      flexSize: 1,
      name: 'FinancialInstitution',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Cliente',
      flexSize: 2,
      name: 'Client',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Beneficiário',
      flexSize: 2,
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Valor',
      flexSize: 1,
      isOrder: true,
      orderValue: 0,
      mask: 'separator.2',
      currency: true
    },
    {
      label: 'Faturamento',
      flexSize: 1
    },
    {
      label: 'Repasse',
      flexSize: 1
    },
  ];

  firstLoad: boolean = true;
  isLoading: boolean = false;

  constructor(
    private _dialog: MatDialog,
    private _dataService: DataService,
    private _verificationService: ApiVerificationService,
    private _apiContractService: ApiContractService,
    private _dialogService: ApiDialogService,
    private _snackbarService: SnackbarService,
    private _clipboardApi: ClipboardService,
    private _datePipe: DatePipe,
    private _titleCasePipe: TitleCasePipe,
    private _currencyPipe: CurrencyPipe,
    private _location: Location,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.buildFilters();
    this.handleContractsToRefund();
  }

  ngAfterViewInit(): void {
    queueMicrotask(() => this.updateContractsHeaderPin());
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.updateContractsHeaderPin();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateContractsHeaderPin();
  }

  exportarModal(reverseTransfer: boolean): void {
    const dialogRef = this._dialog.open(EstornarCardComponent, {
      disableClose: true,
      data: {},
      maxHeight: '750px',
      maxWidth: '1200px',
      minWidth: '800px',
      panelClass: ['vw-80']
    });

    dialogRef.componentInstance.reverseTransfer = reverseTransfer;
    dialogRef.afterClosed().subscribe(() => { });
  }

  goBack(): void {
    this._location.back();
  }

  createBatchForContract(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Criar lote de faturamento',
        title: 'Caso prossiga, um lote de faturamento será criado para o contrato selecionado. Deseja continuar?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this._apiContractService.createBatchForContract(this.createBatch.contractId!).subscribe({
          next: (result) => {
            this._snackbarService.openSnackBar('Lote criado com sucesso!', 'success');
            this._router.navigate(['faturamento-contratos', 'detalhes-lote', result.Data.BatchId]);
          },
          error: () => {
            this._apiContractService.clearContractsSelection();
          },
        });
      }
    });
  }

  applyInlineFilters(event: {
    searchText: string;
    filters: IFilterContracts;
  }): void {
    this.searchText = event.searchText;
    this.search = this.normalizeSearchText(event.searchText);
    this.skip = 0;
    this.paginationResetKey += 1;
    this._dataService.applyFilters(event.filters);
  }

  private normalizeSearchText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  exportToClipboard(): void {

    let searchData = {
      Context: this.currentContext,
      Status: this.filters.Status,
      BatchStatuses: this.filters.BatchStatuses,
      StatusOfOnlending: this.filters.StatusOfOnlending,
      OrderStatus: this.filters.OrderStatus,
      Stages: this.filters.Stages,
      Text: this.search,
      Skip: 0,
      Take: 43012,
      FieldsOrder: [...this.fields],
      WithoutBatch: this.filters.WithoutBatch,
      IsZeroRate: this.filters.IsZeroRate,
      ContractBatchMode: this.filters.ContractBatchMode,
      RateMode: this.currentContext === 'invoice' ? this.filters.RateMode : this.filters.TransferRateMode,
      TransferRateMode: this.filters.TransferRateMode
    };

    this.getContractsRequest(searchData).subscribe({
      next: (res: IGenericResult<IContractSearchData>) => {

        let content: string = 'Nº do Contrato\tFase\tBanco\tCliente\tCPF Cliente\tData Contrato\tStatus do Contrato\r\n';

        if (res.Data.Contracts.length > 0) {
          res.Data.Contracts.forEach((contract: IListContract) => {
            content += `${contract.Number}\t${contract.StageName}\t${this._titleCasePipe.transform(contract.FinancialInstitution)}\t${this._titleCasePipe.transform(contract.Client)}\t${contract.ClientDocument}\t${this._datePipe.transform(contract.ContractDate, 'dd/MM/yyyy')}\t${this._titleCasePipe.transform(this.formatStatusText(contract.Status))}\r\n`;
          });
        }

        navigator.clipboard.writeText(content)
          .then(() => {
            this._snackbarService.openSnackBar('Copiado para área de transferência!', 'success');
          });
      }
    });
  }

  formatStatusText(text: string): string {
    const splittedText = text.split(' ');
    let status: string = splittedText[splittedText.length - 1];

    if (status.toLowerCase().trim() === 'approval') status = 'Aprovação';

    return status;
  }

  private getContracts(
    pushContracts: boolean = false,
    pagination?: IPagination
  ): void {
    let searchData = {
      Context: this.currentContext,
      Status: this.filters.Status,
      BatchStatuses: this.filters.BatchStatuses,
      StatusOfOnlending: this.filters.StatusOfOnlending,
      OrderStatus: this.filters.OrderStatus,
      Stages: this.filters.Stages,
      Text: this.search,
      Skip: this.skip,
      Take: this.take,
      FieldsOrder: [...this.fields],
      IsZeroRate: this.filters.IsZeroRate,
      WithoutBatch: this.filters.WithoutBatch,
      ContractBatchMode: this.filters.ContractBatchMode,
      RateMode: this.currentContext === 'invoice' ? this.filters.RateMode : this.filters.TransferRateMode,
      TransferRateMode: this.filters.TransferRateMode
    };

    if (pagination) {
      searchData = { ...searchData, ...pagination };
    }

    if (!pushContracts) {
      this.isLoading = true;
    }

    this.getContractsRequest(searchData).subscribe({
      next: (res) => {
        this.totalAmount = res.Data.AmountTotal;
        this.count = res.Count;
        this.firstLoad = false;
        this.isLoading = false;

        this._dataService.setHeaderSummary([
          { label: 'Contratos', value: this.count },
          { label: 'Valor total', value: this._currencyPipe.transform(this.totalAmount, 'BRL') },
        ]);

        if (pushContracts) {
          this.contracts.push(...res.Data.Contracts);
        } else {
          this.contracts = res.Data.Contracts;
        }

        queueMicrotask(() => this.updateContractsHeaderPin());
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  buildFilters(): void {

    this._dataService.listFilters
      .pipe(debounceTime(300))
      .subscribe((filters) => {
        this.filters = filters;

        if (this.firstLoad) {
          let storageFilter = localStorage.getItem('bag_filter');

          if (storageFilter != null) {
            this.filters = JSON.parse(storageFilter);
          }
        }

        this.setCurrentContext(this.filters.Context ?? 'invoice');

        this.skip = 0;
        this.getContracts();
      });
  }

  handleContractsToRefund(): void {
    this._apiContractService.getContractsArray().subscribe({
      next: (res) => {
        this.checkedContracts = [...res];
        this.updateCreateBatchState(this.checkedContracts);
      }
    });
  }

  handlePagination(pagination: IPagination): void {
    this.skip = pagination.Skip;
    this.take = pagination.Take;
    this.getContracts(true);
  }

  orderChange(fields: IFieldOrder[]): void {
    this.fields = [...fields];
    this.paginationResetKey += 1;
    this.getContracts(false, { Skip: 0, Take: this.skip + this.take });
  }

  private getContractsRequest(searchData: IContractSearchData | any) {
    return this.currentContext === 'transfer'
      ? this._verificationService.getTransferContracts(searchData)
      : this._verificationService.getContracts(searchData);
  }

  private setCurrentContext(context: 'invoice' | 'transfer'): void {
    this.currentContext = context;

    if (context === 'transfer') {
      this.createBatch = { showCreateBatchButton: false };
      this.checkedContracts = [];
      this._apiContractService.clearContractsSelection();
    }

    this.updateCreateBatchState(this.checkedContracts);
  }

  private updateCreateBatchState(contracts: IListContract[]): void {
    if (this.currentContext !== 'invoice' || contracts.length !== 1) {
      this.createBatch = { showCreateBatchButton: false };
      return;
    }

    this.createBatch = {
      showCreateBatchButton: true,
      contractId: contracts[0].ContractId
    };
  }

  private updateContractsHeaderPin(): void {
    if (!this.enablePinnedHeader) {
      this.isContractsHeaderPinned = false;
      this.contractsHeaderHeight = 0;
      this.contractsHeaderLeft = 0;
      this.contractsHeaderWidth = 0;
      return;
    }

    const headerElement = this.contractsHeaderFixRef?.nativeElement;
    const regionElement = this.contractsRegionRef?.nativeElement;
    const listElement = this.contractsListRef?.nativeElement;

    if (!headerElement || !regionElement || !listElement) {
      return;
    }

    const regionRect = regionElement.getBoundingClientRect();
    const listRect = listElement.getBoundingClientRect();
    const headerHeight = headerElement.offsetHeight;
    const shouldPin = regionRect.top <= 0 && listRect.bottom > headerHeight + 12;

    this.contractsHeaderHeight = headerHeight;
    this.contractsHeaderLeft = listRect.left;
    this.contractsHeaderWidth = listRect.width;
    this.isContractsHeaderPinned = shouldPin;
  }
}
